import { FC } from 'react'
import styles from './login-button.module.scss'
import Button from '../Button'
import classNames from '@/utils/helpers/class-names.helper'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'next/router'

type LoginButtonProps = {
  className?: string
}

const LoginButton: FC<LoginButtonProps> = ({ className }) => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <Button
      className={classNames(styles.button, className)}
      onClick={() =>
        router.push({ query: { ...router.query, auth: 'login' } }, undefined, { scroll: false })
      }
    >
      {t('login')}
    </Button>
  )
}

export default LoginButton
